import { makeApiCall } from "../apiRequest";

export default {
  state: {
    dashboardContent: [],
    activeTemplateDashboard: [],
    dashboardTickets: [],
    employeesAndManagers: [],
  },
  getters: {
    getDashboardContent: (state) => state.dashboardContent,
    getActiveTemplateDashboard: (state) => state.activeTemplateDashboard,
    getDashboardTickets: (state) => state.dashboardTickets,
    getEmployeesAndManagers: (state) => state.employeesAndManagers,
  },
  actions: {
    sendNotificationToAll({ commit }, payload) {
      const url = `notification/sendNotificationToAll`;
      const response = makeApiCall(url, "POST", payload);
      return response;
    },
    getMaintenanceTemplates({ commit }, payload) {
      const url = `maintenanceTasks/getMaintenanceActive`;
      const response = makeApiCall(url, "POST", payload);
      return response;
    },
    async getEmployeesAndManagers({ commit }) {
      const url = `dashboard/admin/getEmployeesAndManagers`;
      const response = await makeApiCall(url, "GET");
      if (!response.error) {
        commit("setEmployeesAndManagers", response.data.data);
      }
    },
    async getDashboardContent({ commit }) {
      const url = `dashboard/admin`;
      const response = await makeApiCall(url, "GET");
      if (!response.error) {
        commit("setDashboardContent", response.data.data);
      }
    },
    async getActiveTemplateDashboard({ commit }, payload) {
      const url = `dashboard/admin/activeTemplates?fromDate=${payload.startDate}&toDate=${payload.endDate}`;
      const response = await makeApiCall(url, "GET");
      if (!response.error) {
        commit("setActiveTemplateDashboard", response.data.data);
      }
    },
    async getDashboardTickets({ commit }, payload) {
      const url = `ticket/getAll`;
      const response = await makeApiCall(url, "POST", payload);
      if (!response.error) {
        commit("setDashboardTickets", response.data.data.tickets);
      }
      return response;
    },
    async sendNotificationByAdmin({ commit }, payload) {
      const response = await makeApiCall(
        "notification/sendNotificationByAdmin",
        "POST",
        payload
      );
      return response;
    },
  },
  mutations: {
    setEmployeesAndManagers: (state, payload) =>
      (state.employeesAndManagers = payload),
    setDashboardContent: (state, payload) => (state.dashboardContent = payload),
    setActiveTemplateDashboard: (state, payload) =>
      (state.activeTemplateDashboard = payload),
    setDashboardTickets: (state, payload) => (state.dashboardTickets = payload),
  },
};
